import 'popper.js';
import $ from "jquery";
// import 'jquery-ui';
// import 'jquery-ui/ui/widgets/datepicker.js';
// import 'jquery-ui/ui/widgets/sortable.js';
// import 'jquery-ui/ui/widgets/dialog.js';
import 'bootstrap';
import './slider.js';
import 'slick-carousel';

window.$ = window.jQuery = $; // Make $ available in views

let carousels = document.querySelectorAll('.carousel');
carousels.forEach(function (carousel) {
    document.querySelector('.carousel-inner :first-child').classList.add('active');

    let mobileText = carousel.querySelector('.mobile-text');

    if (mobileText) {
        let active = 0;
        carousel.querySelectorAll('.text-position').forEach(function (textBlock, i) {
            let textEl = textBlock.cloneNode(true);
            if (i != active) {
                textEl.style.opacity = 0;
                textEl.style.zIndex = 0;
            }
            mobileText.appendChild(textEl);
        });

        mobileText.style.height = mobileText.querySelectorAll('.text-position')[active].scrollHeight + 'px';
    }

    $(carousel).on('slide.bs.carousel', function (i) {
        let carouselId = $(i.target).attr('id');
        let index = i.to;
        $('.carousel-indicators').each(function () {
            if ($(this).find('[data-target="#' + carouselId + '"]').length > 0) {
                $(this).find('[data-target="#' + carouselId + '"]').removeClass('active');
                $(this).find('[data-target="#' + carouselId + '"]:eq(' + index + ')').addClass('active');
            }
        });
        if (mobileText) {
            mobileText.querySelectorAll('.text-position')[i.from].style.opacity = 0;
            mobileText.querySelectorAll('.text-position')[i.from].style.zIndex = 0;
            mobileText.querySelectorAll('.text-position')[i.to].style.opacity = 1;
            mobileText.querySelectorAll('.text-position')[i.to].style.zIndex = 1;
            mobileText.style.height = mobileText.querySelectorAll('.text-position')[i.to].scrollHeight + 'px';
        }
    })

    if (mobileText) {
        mobileText.querySelectorAll('.text-position')[0].style.zIndex = 1;
    }
});

let isTouch = 'ontouchstart' in window;
document.documentElement.className += isTouch ? ' touch ' : ' no-touch ';

$(document).ready(function () {
    $.ajaxSetup({
        headers: { 'X-CSRF-Token': $('meta[name=csrf-token]').attr('content') }
    });
});